import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type INativeNotificationSettings } from '@/types/INativeNotificationSettings';
import {
  readNativeNotificationSettings,
  saveNativeNotificationSettings
} from '@/services/nativeNotifications/nativeNotificationSettingsStorage';

const initialState: INativeNotificationSettings =
  readNativeNotificationSettings();

const nativeNotificationSettings = createSlice({
  name: 'nativeNotificationSettings',
  initialState,
  reducers: {
    setNativeNotificationsEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
      saveNativeNotificationSettings(state);
    }
  }
});

export const { setNativeNotificationsEnabled } =
  nativeNotificationSettings.actions;

export default nativeNotificationSettings.reducer;
